import styled from "styled-components";

import { ScrollZone } from "../../Components";

export const StyledScrollZone = styled(ScrollZone)`
  padding-top: ${({ theme }) => theme.spacing.spacing_32};
  padding-bottom: ${({ theme }) => theme.spacing.spacing_32};

  ${props => props.theme.breakpoints.tablet} {
    padding-top: ${({ theme }) => theme.spacing.spacing_64};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_64};
  }

  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_80};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_80};
  }
`;
